const actions = {
    changeLanguage(val) {
      // console.log(val);
      return (dispatch, state) => {
        dispatch({
          type: 'CHANGE_LANGUAGE',
          val
        });
      };
    },
    setGoodLinks(data) {
      return (dispatch) => {
        // 同时存储到 localStorage
        localStorage.setItem('goodLinks', JSON.stringify(data));
        dispatch({
          type: 'SET_GOOD_LINKS',
          payload: data
        });
      };
    }
  };
  
  export default actions;